module.exports = __webpack_public_path__ + "static/media/snackpass.7d144e2c.png";